import { Button } from "@material-ui/core";

function ButtonLayout ( props ) {

    return <Button {...props} />

}

export default ButtonLayout;
